<template>
  <custom-dialog
    width="1400px"
    :title="$t('fms_invoice_bill_msg_dialog.kai_piao_ji_lu')"
    :visible="visible"
    v-on="$listeners"
    class="invoice-bill-msg-dialog"
    :append-to-body="true"
  >
    <div class="dialog-body">
      <div class="table-bd">
        <custom-table
          :data="tableList"
          tableCode="fms_invoice_records"
          @sort="sortChange"
          @filter="filterChange"
          :slots="['invoiceNum', 'invoiceType']"
          :filterArr="filterArr"
        >
          <template
            slot="invoiceType"
            slot-scope="scope"
          >{{ getItemNameByTypeAndClass(scope.row.invoiceType, scope.row.invoiceClass) }}</template>
          <template
            slot="invoiceNum"
            slot-scope="scope"
          >
            <template v-if="scope.row.isRedInvoice">
              <span
                :class="invoiceDetail ? 'cell-link' : ''"
                @click="invoiceDetail ? onInvoiceDetails(scope.row.invoiceId, scope.row.isRedInvoice) : null"
              >{{ scope.row.invoiceNum || '-' }}</span>
              <!-- /
              <span
                :class="invoiceDetail ? 'cell-link' : ''"
                @click="invoiceDetail ? onInvoiceDetails(scope.row.oldInvoiceId) : null"
              >{{ scope.row.oldInvoiceNum || '-' }}</span> -->
            </template>
            <template v-else>
              <span
                :class="invoiceDetail ? 'cell-link' : ''"
                @click="invoiceDetail ? onInvoiceDetails(scope.row.invoiceId, scope.row.isRedInvoice) : null"
              >{{ scope.row.invoiceNum || '-' }}</span>
            </template>
          </template>

        </custom-table>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
    </div>
    <!-- 发票详情 -->
    <invoice-details-dialog
      v-if="dialogVisible1"
      :model="dialogModel1"
      @close="dialogVisible1 = false"
    ></invoice-details-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import invoiceDetailsDialog from '@/pages/fms/components/invoice_details_dialog.vue';
import invoiceTypeMixins from '@/mixins/invoice_type_mixins.js';

export default {
  mixins: [dialogMixins, invoiceTypeMixins],
  props: {
    // false-收款  true-付款
    paymentOrReceivable: {
      type: Boolean,
      default: false
    },
    // 是否能点击查看发票详情
    invoiceDetail: {
      type: Boolean,
      default: false
    }
  },
  components: {
    invoiceDetailsDialog
  },
  computed: {
    filterArr() {
      /**
       * 购买方（应收列表显示） buyerOrgName
销售方（应付列表显示） sellerOrgName
       */
      const isReceivable = !this.paymentOrReceivable;
      return isReceivable ? ['sellerOrgName'] : ['buyerOrgName'];
    }
  },
  data() {
    return {
      tableList: [],
      dialogVisible1: false,
      dialogModel1: {},
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onInvoiceDetails: function (invoiceId, isRedInvoice) {
      // isRedInvoice true是冲红
      // isRedInvoice false是蓝票
      this.dialogModel1.type = isRedInvoice;
      this.dialogModel1.title = this.$t('fms_invoice_bill_msg_dialog.fa_piao_xiang_qing');
      this.dialogModel1.invoiceId = invoiceId;
      this.dialogVisible1 = true;
    },
    init() {
      const billId = this.model.data.billId;
      const url = `${apis.portalBillInvoiceDetail}/${billId}`;
      this.$getJSON(url).then((res) => {
        this.tableList = res.data || [];
      });
    }
  }
};
</script>

<style lang="scss">
</style>
